import React from 'react';
import styledComponents from './styles';
import commonStyles from '../../../../components/DesignPatternV2.0/commonStyles';

const {
  H2
} = commonStyles;

const {
  InformationSection,
  Table,
  TableHeader,
  TableRow,
  InformationMobile,
  RowContainer,
  RowTitle,
  RowDescription
} = styledComponents;

export default function ProjectInformation({fetchedBidData, translations}) {
  return (
    <InformationSection>
      <H2>{translations.projectInformationSection.title}</H2>
      <Table>
        <thead>
          <TableHeader>
            <th>{translations.projectInformationSection.name}</th>
            <th>{translations.projectInformationSection.siteAddress}</th>
            <th>{translations.projectInformationSection.email}</th>
            <th>{translations.projectInformationSection.phone}</th>
          </TableHeader>
        </thead>
        <tbody>
          <TableRow>
            <td>{fetchedBidData.Request.FirstName} {fetchedBidData.Request.LastName}</td>
            <td>{fetchedBidData.Request.FullAddress}</td>
            <td>{fetchedBidData.Request.Email}</td>
            <td>{fetchedBidData.Request.Phone}</td>
          </TableRow>
        </tbody>
      </Table>
      {/* Mobile View */}
      <InformationMobile>
        <RowContainer>
          <RowTitle>{translations.projectInformationSection.name}</RowTitle>
          <RowDescription>{fetchedBidData.Request.FirstName} {fetchedBidData.Request.LastName}</RowDescription>
        </RowContainer>
        <RowContainer>
          <RowTitle>{translations.projectInformationSection.siteAddress}</RowTitle>
          <RowDescription>{fetchedBidData.Request.FullAddress}</RowDescription>
        </RowContainer>
        <RowContainer>
          <RowTitle>{translations.projectInformationSection.email}</RowTitle>
          <RowDescription>{fetchedBidData.Request.Email}</RowDescription>
        </RowContainer>
        <RowContainer>
          <RowTitle>{translations.projectInformationSection.phone}</RowTitle>
          <RowDescription>{fetchedBidData.Request.Phone}</RowDescription>
        </RowContainer>
      </InformationMobile>
      {/* End of Mobile View */}
    </InformationSection>
  )
}
